import decimalFormatter from "../services/decimal-formatters";

export default {
    //TODO: APP
    loading: state => {
        return state.app.loading
    },
    notifications: state => {
        return state.app.notifications || {}
    },
    validationErrors: state => {
        const validations = state.app.notifications.items.filter(i => i.type === 'validation')
        const errors = {}
        for(let i = 0; i < validations.length; i++) {
            if(validations[i].name === 'read_and_accept') {
                validations[i].message = "<strong style='color: red'>Terms & Conditions&nbsp;</strong> must accept to proceed with your order."
            }
            errors[validations[i].name] = validations[i].message
        }

        return errors
    },
    auth: state => {
        return state.app.auth
    },
    isAdmin: state => {
        return state.app.auth && state.app.auth.isAdmin
    },
    isSuperAdmin: state => {
        return state.app.auth && state.app.auth.isSuperAdmin
    },
    //TODO: CART
    cartTotalCount: state => {
        return state.cart.items.reduce((a, b) => a + (Number(b.quantity) || 0), 0)
    },
    itemsTotalPrice: state => {
        return state.cart.items.reduce((a, b) => a + ((Number(b.price) * Number(b.quantity)) || 0), 0)
    },
    cartItems: state => {
        return state.cart.items || []
    },
    cartDefaultDataLayer: state =>
    {
        let defaultLayer =
        [
            JSON.parse(JSON.stringify(state.data_layer_default)),
            JSON.parse(JSON.stringify(state.data_layer_view_cart))

        ]

        return defaultLayer;
    },
    changeDetailsDataLayer: state =>
    {
        let defaultLayer =
        [
            JSON.parse(JSON.stringify(state.data_layer_view_item)),
            JSON.parse(JSON.stringify(state.data_layer_change_detail_view_eec))

        ]

        return defaultLayer;
    },
    updateDetailsDataLayer: state =>
    {
        let defaultLayer =
        [
            JSON.parse(JSON.stringify(state.data_layer_add_to_cart)),
            JSON.parse(JSON.stringify(state.data_layer_add_product_to_cart_eec))

        ]

        return defaultLayer;
    },
    removeDetailsDataLayer: state =>
    {
        let defaultLayer =
        [
            JSON.parse(JSON.stringify(state.data_layer_remove_from_cart)),
            JSON.parse(JSON.stringify(state.data_layer_add_remove_from_cart_eec))

        ]

        return defaultLayer;
    },
    cartLinkedProducts: state => {
        return state.app.cartLinkedProducts || []
    },
    checkoutDefaultDataLayer: state =>
    {
        let defaultLayer =
        [
            JSON.parse(JSON.stringify(state.data_layer_checkout_default)),
            JSON.parse(JSON.stringify(state.data_layer_begin_checkout))

        ]

        return defaultLayer;
    },
    getProductLinkedProducts: state => {
        return state.app.productLinkedProducts || []
    },
    minOrderQuantity: (state, getters) => {
        const items = getters.cartItems.map(i => ({...i, ...{product: state.app.products.find(j => j.id === i.id)}}))
            .filter(i => i.product && i.product.allow_combination);

        let minQtyItem = items.sort(function(a, b) {
            return a.product.min_quantity - b.product.min_quantity;
        })
        return (minQtyItem[0] && minQtyItem[0].product.min_quantity) || null
    },
    coupon: state => {
        return state.cart.coupon || null
    },
    subTotalWithCoupon: (state, getters) => {
        let subTotalWithCoupon = getters.itemsTotalPrice - (state.cart.coupon && state.cart.coupon.amount ? state.cart.coupon.amount : 0);
        return subTotalWithCoupon > 0 ? subTotalWithCoupon : 0
    },
    cartHash: state => {
        return state.cart.hash || null
    },
    cartType: state => {
        return state.cart.cart_type || 0
    },
    cartAppendurl: state => {
        return state.cart.appendurl || null
    },
    sharedCartHash : state => {
        return state.cart.sharedCartHash || null
    },
    //TODO: CHECKOUT
    billingInfo: state => {
        return state.billing_info
    },
    //TODO: SHIPPING
    shippingInfo: state => {
        return state.shipping_info
    },
    shippingMethods: state => {
        return state.shipping_methods
    },
    beforeShippingMethods: state => {
        return state.before_shipping_methods
    },
    shippingMethod: state => {
        if(state.shipping_methods.selected)
        {
             const method = state.shipping_methods.rates.find(i => i.id === state.shipping_methods.selected)

            return {...method, ...{cost: state.shipping_methods.custom_price || method.cost}}
        }
        else
        {
            return null;
        }

    },
    shippingRates: state => {
        return (state.shipping_methods.rates || []).map(i => ({
            ...i,
            ...{cost: i.id === state.shipping_methods.selected && state.shipping_methods.custom_price ? state.shipping_methods.custom_price : i.cost}
        }))
    },
    shippingPrice: state => {
        const method = state.shipping_methods.rates.find(i => i.id === state.shipping_methods.selected)
        return method && typeof method.cost !== 'undefined' ? (state.shipping_methods.custom_price ?? Number(method.cost)) : (state.shipping_methods.custom_price ??  0)
    },
    beforeShippingPrice: state => {
        const method = state.before_shipping_methods.rates.find(i => i.id === state.before_shipping_methods.selected)

        return method && typeof method.cost !== 'undefined' ? (state.shipping_methods.custom_price ?? Number(method.cost)) : (state.shipping_methods.custom_price ??  0)
    },
    shippingPriceWithoutCustom: state => {
        const method = state.shipping_methods.rates.find(i => i.id === state.shipping_methods.selected)
        return method && typeof method.cost !== 'undefined' ? Number(method.cost) : 0
    },
    shippingDefaultPriceWithoutCustom: state => {
        return state.shipping_methods.defaultCost
    },
    shippingIsFree: (state, getters) => {
        return !(getters.shippingPrice > 0)
    },
    beforeShippingIsFree: (state, getters) => {
        return !(getters.beforeShippingPrice > 0)
    },
    isShippingCalculated: state => {
        return !!state.shipping_methods.selected
    },
    //TODO: SHARED DATA
    shareCart: state => {
        return state.share_cart
    },
    totalPrice: (state, getters) => {//TODO
        return Number(getters.subTotalWithCoupon) + Number(getters.shippingPrice)
    },
    //TODO: REQUESTS
    shippingCalculateRequest: (state, getters) => {
        return {
            state: state.shipping_methods.state,
            zipcode: state.shipping_methods.zipcode,
            email: state.shipping_methods.email,
            items: getters.cartItems
        }
    },
    saveAndShareRequest: (state, getters) => {
        return {
            ...getters.shareCart,
            ...{
                shipping_methods: getters.shippingMethods,
                items: getters.cartItems,
                coupon: getters.coupon,
                hash: getters.cartHash,
            }
        }
    },
    saveAndGenerateLinkRequest: (state, getters) => {
        return {
            redirectTo: getters.shareCart.redirectTo,
            shipping_methods: getters.shippingMethods,
            coupon: getters.coupon,
            items: getters.cartItems,
            hash: getters.cartHash,
        }
    },
    expressCheckoutRequest: (state, getters) => {
        const checkoutInfo = Object.assign({}, getters.billingInfo, getters.shippingInfo)
        checkoutInfo.shipping_first_name = checkoutInfo.same_as_billing ? checkoutInfo.billing_first_name : checkoutInfo.shipping_first_name
        checkoutInfo.shipping_last_name = checkoutInfo.same_as_billing ? checkoutInfo.billing_last_name : checkoutInfo.shipping_last_name
        checkoutInfo.shipping_company_name = checkoutInfo.same_as_billing ? checkoutInfo.billing_company_name : checkoutInfo.shipping_company_name
        checkoutInfo.shipping_country = checkoutInfo.same_as_billing ? checkoutInfo.billing_country : checkoutInfo.shipping_country
        checkoutInfo.shipping_street_address1 = checkoutInfo.same_as_billing ? checkoutInfo.billing_street_address1 : checkoutInfo.shipping_street_address1
        checkoutInfo.shipping_street_address2 = checkoutInfo.same_as_billing ? checkoutInfo.billing_street_address2 : checkoutInfo.shipping_street_address2
        checkoutInfo.shipping_city = checkoutInfo.same_as_billing ? checkoutInfo.billing_city : checkoutInfo.shipping_city
        checkoutInfo.shipping_phone_number = checkoutInfo.same_as_billing ? checkoutInfo.billing_phone_number : checkoutInfo.shipping_phone_number
        checkoutInfo.shipping_state = checkoutInfo.same_as_billing ? checkoutInfo.billing_state : checkoutInfo.shipping_state
        checkoutInfo.shipping_zipcode = checkoutInfo.same_as_billing ? checkoutInfo.billing_zipcode : checkoutInfo.shipping_zipcode
        checkoutInfo.shipping_email_address = checkoutInfo.same_as_billing ? checkoutInfo.billing_email_address : checkoutInfo.shipping_email_address

        return {
            ...checkoutInfo,
            ...{items: getters.cartItems},
            ...{rate: getters.shippingMethod},
        }
    },
    saveCartRequest: (state, getters) => {
        let email = null

        if(getters.billingInfo && getters.billingInfo.billing_email_address) {
            email = getters.billingInfo.billing_email_address
        }

        if(getters.shippingInfo && getters.shippingInfo.shipping_email_address) {
            email = getters.shippingInfo.shipping_email_address
        }

        if(getters.shippingMethods && getters.shippingMethods.email) {
            email = getters.shippingMethods.email
        }

        const items = []

        for(let i = 0; i < getters.cartItems.length; i++) {
            const item = Object.assign({}, getters.cartItems[i])
            delete item.product
            items.push(item)
        }

        return {
            items: items,
            shipping_methods: getters.shippingMethods,
            shipping_info: getters.shippingInfo,
            billing_info: getters.billingInfo,
            coupon: (getters.itemsTotalPrice > 0 && getters.itemsTotalPrice) ? getters.coupon : null,
            cart_type: getters.cartType,
            email,
        }
    },
}
